<template>
  <div class="col-md-3">
    <div class="widget style1" :class="color">
      <div class="row">
        <div class="col-xs-4">
          <i :class="icon"></i>
        </div>
        <div class="col-xs-8 text-right">
          <span> {{ title }} </span>
          <h2 @click="handleClick" class="font-bold clickable-element" v-if="!isVoidItemCard">Print</h2>
          <h2 class="font-bold" v-else>{{ sale }}</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PosSaleCard",
  props: {
    title: {
      type: String,
    },
    color: {
      type: String,
    },
    icon: {
      type: String,
    },
    sale: {
      type: Number,
      default: 0,
    },
    isVoidItemCard: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      this.$emit('cardClick'); // Emit a custom event named 'cardClick'
    }
  }
}
</script>



<style scoped>
.clickable-element {
  cursor: pointer;
}
</style>